import React, { Suspense, useEffect } from 'react' // Added useEffect
import { useLocation } from 'react-router-dom'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import { useAnalyticsTracking } from 'src/utils/GoogleAnalytics'
import { useToastAlert } from 'src/stores/ToastContext'
import classNames from 'classnames'
import ProgramsSkeleton from './ProgramsSkeleton'
import UpcomingEvents from './UpcomingEvents'
import PastEvents from './PastEvents'
import NextEvent from './NextEvent'

const ProgramsHomePage = () => {
  const googleTracking = useAnalyticsTracking()
  const { state } = useLocation()
  const { resetAlert } = useToastAlert()

  // Clear any active or lingering toast notifications the moment this view mounts
  useEffect(() => {
    resetAlert()
  }, [resetAlert])

  googleTracking('login_complete', 'sign_in_page', null, state?.fromLogin || false)

  return (
    <Suspense fallback={<ProgramsSkeleton />}>
      <div className={classNames(generalStyles.smallWidth, generalStyles.pt13)}>
        <NextEvent />
        <UpcomingEvents />
        <PastEvents />
      </div>
    </Suspense>
  )
}

export default ProgramsHomePage
